import './mobileSidePanel.scss';

// CSS class name mapping — replaces withStyles(EmployeeDashboardMobileSidePanelStyles).
// Used by uiGenerators.js functions bound via .bind(this) that read this.props.classes.
const MOBILE_SIDEPANEL_CLASSES = {
    viewContainer: 'msp-view-container',
    privateOfferViewContainer: 'msp-private-offer-view-container',
    appbar: 'msp-appbar',
    notificationBell: 'msp-notification-bell',
    shiftDetail: 'msp-shift-detail',
    shiftInfo: 'msp-shift-info',
    ownerSection: 'msp-owner-section',
    managerSettingButton: 'msp-manager-setting-button',
    managerSettingButtonText: 'msp-manager-setting-button-text',
    managerSettingButtonArrow: 'msp-manager-setting-button-arrow',
    segments: 'msp-segments',
    bottomBar: 'msp-bottom-bar',
    privateEmployeeWarningModal: 'msp-private-employee-warning-modal',
    vtoSidePanelSection: 'msp-vto-sidepanel-section',
    primaryButton: 'msp-primary-button',
    buttonDisabled: 'msp-button-disabled',
    secondaryButton: 'msp-secondary-button',
    formButton: 'msp-form-button',
    formButtonWithHover: 'msp-form-button-with-hover',
    viewHeader: 'msp-view-header',
    subHeader: 'msp-sub-header',
    shiftCard: 'msp-shift-card',
    shiftInfoHeaderEmployeeNameWrapper: 'msp-shift-info-header-ee-name-wrapper',
    historyItemContainer: 'msp-history-item-container',
    historyLogFirst: 'msp-history-log-first',
    historyLogName: 'msp-history-log-name',
    historyLogshiftTime: 'msp-history-log-shift-time',
    historyLogDate: 'msp-history-log-date',
    contentWrapper: 'msp-content-wrapper',
    selectWrapper: 'msp-select-wrapper',
    preferredDayPickerContainer: 'msp-preferred-day-picker-container',
    preferredDateNoPadding: 'msp-preferred-date-no-padding',
    recipientNameStyle: 'msp-recipient-name-style',
};

export default MOBILE_SIDEPANEL_CLASSES;
